import * as React from "react";
import {
  useFindAllCommunities,
  useFindByEntityType,
  useMyIdentities,
} from "@njoy/controller";
import { Field, useFormikContext } from "formik";
import { Select } from "antd";
import { InputField } from "../../../shared/InputField";
import { SelectField } from "../../../shared/SelectField";
import { SearchableSelectField } from "../../../shared/SearchableSelectField";

const { Option } = Select;

type Page1FormValues = {
  communityId: string;
  id: string;
  communityEntityId: string;
  idNumber: string;
  isStudentCommunity: boolean;
  isNyscCommunity: boolean;
  requiresCommunityEntity: boolean;
};

export const Page1: React.FC = () => {
  const { communities = [], loading } = useFindAllCommunities();
  const { myIdentities = [] } = useMyIdentities({ limit: 5, offset: 0 });
  const { values, setFieldValue } = useFormikContext<Page1FormValues>();
  const selectedCommunity = communities.find(
    (community) => community.id === values.communityId
  );
  

  const isStudentCommunity = selectedCommunity?.alias.trim().toLowerCase() === "student";
  const nyscMember = selectedCommunity?.alias.trim().toLowerCase().includes("nysc");
  const {communityEntities = [], loading: loadingCommunityEntities} = useFindByEntityType(selectedCommunity?.alias || "");
  const shouldShowCommunityEntitySelect = communityEntities.length > 0;
  const communityEntityPlaceholder = isStudentCommunity
    ? "Select University"
    : "Select Sub Community";

  const idNumberLabel = isStudentCommunity ? "Matriculation Number" : "ID Number";
  
  const idNumberPlaceholder = (() => {
    switch (true) {
      case selectedCommunity?.alias.trim().toLowerCase() === "student":
        return "Matriculation Number";

      case nyscMember:
        return "State Code";

      default:
        return "ID Number";
    }
  })();

  React.useEffect(() => {
    setFieldValue("requiresCommunityEntity", shouldShowCommunityEntitySelect, false);
  }, [setFieldValue, shouldShowCommunityEntitySelect]);

  return (
    <div className="pt-5 h-full px-[1rem] flex flex-col align-items gap-2 justify-center ">
      <Field
        name="communityId"
        component={SelectField}
        placeholder="Select ID"
        onValueChange={(newValue: string) => {
          const nextCommunity = communities.find(
            (community) => community.id === newValue
          );
          const nextCommunityAlias = nextCommunity?.alias?.trim().toLowerCase() || "";

          setFieldValue("communityId", newValue, false);
          setFieldValue("isStudentCommunity", nextCommunityAlias === "student", false);
          setFieldValue("isNyscCommunity", nextCommunityAlias.includes("nysc"), false);
          setFieldValue("requiresCommunityEntity", false, false);
          setFieldValue("id", "", false);
          setFieldValue("communityEntityId", "", false);
          setFieldValue("idNumber", "", false);
        }}
      >
        {loading ? (
          <Option value="" disabled>
            Loading...
          </Option>
        ) : (
          communities.map((c) => (
            <Option
              key={c.id}
              value={c.id}
              disabled={
                // c.alias === "Njoy Youth" ||
                // c.name === "National Youth Service Corps" ||
                myIdentities.some((identity) => identity.community?.id === c.id)
              }
            >
              {c.alias}
            </Option>
          ))
        )}
      </Field>

      {shouldShowCommunityEntitySelect && (
        <Field
          name="id"
          component={SearchableSelectField}
          placeholder={communityEntityPlaceholder}
          searchPlaceholder="Search"
          onValueChange={(newValue: string) => {
            setFieldValue("id", newValue, false);
            setFieldValue("communityEntityId", newValue, false);
            setFieldValue("idNumber", "", false);
          }}
        >
          {loadingCommunityEntities ? (
            <Option value="" disabled>
              Loading...
            </Option>
          ) : (
            communityEntities.map((communityEntity) => (
              <Option key={communityEntity.id} value={communityEntity.id}>
                {communityEntity.shortName
                  ? `${communityEntity.name} (${communityEntity.shortName})`
                  : communityEntity.name}
              </Option>
            ))
          )}
        </Field>
      )}

      <label className="text-[#CECECF]" htmlFor="email">
        {idNumberLabel}
      </label>
      <Field
        name="idNumber"
        placeholder={idNumberPlaceholder}
        component={InputField}
      />
    </div>
  );
};
